import { render, staticRenderFns } from "./TimeInfoGroup.vue?vue&type=template&id=2ffd534a&scoped=true&"
import script from "./TimeInfoGroup.vue?vue&type=script&lang=js&"
export * from "./TimeInfoGroup.vue?vue&type=script&lang=js&"
import style0 from "./TimeInfoGroup.vue?vue&type=style&index=0&id=2ffd534a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd534a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
})
